import {_} from 'lodash';
import {IImportFormat, TDataSourceType} from "../index";

export namespace nsDataSource {

    export interface IImportFormatType {
        description: `ruleset.datasource.${TDataSourceType}.description`
        education: boolean
        label: `ruleset.datasource.${TDataSourceType}`
        name: TDataSourceType
    }

    export const ImportFormatTypes: Record<TDataSourceType, IImportFormatType> = {
        hr: {
            description: 'ruleset.datasource.hr.description',
            education: false,
            label: 'ruleset.datasource.hr',
            name: 'hr',
        },
        edu: {
            description: 'ruleset.datasource.edu.description',
            education: true,
            label: 'ruleset.datasource.edu',
            name: 'edu',
        }
    } as const

    export function filterImportFormats(importformats: IImportFormat[], type: TDataSourceType): IImportFormat[] {
        return importformats.filter(o => {
            switch (type) {
                case "hr":
                    return !o.education;
                case "edu":
                    return o.education;
            }
        })
    }

    export function hasImportFormatType(importformats: IImportFormat[], type: TDataSourceType): boolean {
        return !!filterImportFormats(importformats, type).length
    }

    export function getImportFormatType(importformat: IImportFormat): TDataSourceType {
        return importformat.education ? 'edu' : 'hr';
    }

    export function hasMultipleImportFormatTypes(importformats: IImportFormat[]): boolean {
        return _(importformats).map(getImportFormatType).uniq().size() > 1;
    }

}